import React, { useState, useEffect } from 'react';
import SignatureCanvas from './SignatureCanvas';

// Form field options based on the JotForm
export const SKINCARE_CONCERNS = [
  { value: 'dry_flakey', label: 'Dry Flakey Skin', labelCn: '干燥脱皮肌肤' },
  { value: 'breakouts', label: 'Breakouts', labelCn: '痘痘' },
  { value: 'wrinkles', label: 'Wrinkles', labelCn: '皱纹' },
  { value: 'blackheads', label: 'Blackheads', labelCn: '黑头' },
  { value: 'acne', label: 'Acne', labelCn: '粉刺' },
  { value: 'loss_firmness', label: 'Loss of Firmness', labelCn: '皮肤松弛' },
  { value: 'clogged_pores', label: 'Clogged Pores', labelCn: '毛孔堵塞' },
  { value: 'skin_texture', label: 'Skin Texture', labelCn: '皮肤纹理问题' },
  { value: 'large_pores', label: 'Large Pores', labelCn: '毛孔粗大' },
  { value: 'hyperpigmentation', label: 'Hyper-Pigmentation / Uneven Skin Tone', labelCn: '色素沉着 / 肤色不均' },
  { value: 'redness', label: 'Redness', labelCn: '皮肤发红' },
  { value: 'sensitivity', label: 'Skin Sensitivity', labelCn: '皮肤敏感' },
  { value: 'rosacea', label: 'Rosacea', labelCn: '玫瑰痤疮' },
  { value: 'oily_skin', label: 'Oily Skin', labelCn: '油性肌肤' },
  { value: 'milia', label: 'Milia', labelCn: '脂肪粒' },
  { value: 'fine_lines', label: 'Fine Lines', labelCn: '细纹' },
  { value: 'other', label: 'Other', labelCn: '其他' },
];

export const FACIAL_REASONS = [
  { value: 'relaxation', label: 'Relaxation', labelCn: '放松身心' },
  { value: 'education', label: 'Skincare Education', labelCn: '护肤知识学习' },
  { value: 'best_for_skin', label: 'Help with What is Best for My Skin', labelCn: '帮助了解最适合我肌肤的护理方案' },
  { value: 'other', label: 'Other', labelCn: '其他' },
];

export const DAILY_PRODUCTS = [
  { value: 'soap', label: 'Soap', labelCn: '香皂' },
  { value: 'cleanser', label: 'Cleanser', labelCn: '洁面产品' },
  { value: 'toner', label: 'Toner', labelCn: '爽肤水' },
  { value: 'serum', label: 'Serum', labelCn: '精华液' },
  { value: 'mask', label: 'Mask', labelCn: '面膜' },
  { value: 'exfoliant', label: 'Exfoliant (physical or chemical)', labelCn: '去角质产品（物理或化学）' },
  { value: 'eye_cream', label: 'Eye Cream', labelCn: '眼霜' },
  { value: 'moisturizer', label: 'Moisturizer', labelCn: '保湿霜' },
  { value: 'spf', label: 'SPF', labelCn: '防晒霜' },
  { value: 'retinol', label: 'Vitamin A (retinol)', labelCn: '维生素A（视黄醇）' },
  { value: 'other', label: 'Other', labelCn: '其他' },
];

export const ALLERGIES = [
  { value: 'aspirin', label: 'Aspirin', labelCn: '阿司匹林' },
  { value: 'latex', label: 'Latex', labelCn: '乳胶' },
  { value: 'fruits', label: 'Fruits', labelCn: '水果' },
  { value: 'shellfish', label: 'Shellfish', labelCn: '贝类' },
  { value: 'lidocaine', label: 'Lidocaine', labelCn: '利多卡因' },
  { value: 'fragrance', label: 'Fragrance/Essential oils', labelCn: '香料/精油' },
  { value: 'tree_nuts', label: 'Tree Nuts', labelCn: '坚果' },
  { value: 'dairy', label: 'Dairy', labelCn: '乳制品' },
  { value: 'sunscreen', label: 'Sunscreen', labelCn: '防晒霜' },
  { value: 'pollen', label: 'Pollen', labelCn: '花粉' },
  { value: 'none', label: 'None', labelCn: '无过敏史' },
  { value: 'other', label: 'Other', labelCn: '其他' },
];

export const ACTIVE_PRODUCTS = [
  { value: 'aha', label: 'AHA (glycolic acid, lactic acid, etc.)', labelCn: 'AHA（果酸，如乙醇酸、乳酸等）' },
  { value: 'bha', label: 'BHA (salicylic acid)', labelCn: 'BHA（水杨酸）' },
  { value: 'vitamin_a', label: 'Vitamin A derivative (retinol/retinoids)', labelCn: '维生素A衍生物（视黄醇/类维生素A）' },
  { value: 'scrubs', label: 'Exfoliating scrubs', labelCn: '去角质磨砂产品' },
  { value: 'prescription', label: 'Prescription Topicals', labelCn: '处方外用药物' },
];

export const HEALTH_CONDITIONS = [
  { value: 'hormone_imbalance', label: 'Hormone Imbalance', labelCn: '激素失调' },
  { value: 'cancer', label: 'Cancer/Systemic disease', labelCn: '癌症/系统性疾病' },
  { value: 'high_blood_pressure', label: 'High Blood Pressure', labelCn: '高血压' },
  { value: 'diabetes', label: 'Diabetes', labelCn: '糖尿病' },
  { value: 'heart_problem', label: 'Heart problem', labelCn: '心脏问题' },
  { value: 'arthritis', label: 'Arthritis', labelCn: '关节炎' },
  { value: 'autoimmune', label: 'Auto-immune Disorder', labelCn: '自身免疫性疾病' },
  { value: 'asthma', label: 'Asthma', labelCn: '哮喘' },
  { value: 'epilepsy', label: 'Epilepsy/Seizures', labelCn: '癫痫/抽搐' },
  { value: 'cold_sores', label: 'Cold sores', labelCn: '唇疱疹' },
  { value: 'hiv_aids', label: 'HIV/AIDS', labelCn: '艾滋' },
  { value: 'lupus', label: 'Lupus', labelCn: '狼疮' },
  { value: 'depression_anxiety', label: 'Depression/Anxiety', labelCn: '抑郁/焦虑' },
  { value: 'headaches_migraines', label: 'Headaches/Migraines', labelCn: '头痛/偏头痛' },
  { value: 'none', label: 'None', labelCn: '无上述健康状况' },
  { value: 'other', label: 'Other', labelCn: '其他' },
];

// Form data interface
export interface FacialConsentFormData {
  // Personal Info
  firstName: string;
  lastName: string;
  phone: string;
  email: string;
  addressStreet: string;
  addressStreet2: string;
  addressCity: string;
  addressState: string;
  addressZip: string;

  // Skin Data
  hadFacialBefore: boolean | null;
  skincareConcerns: string[];
  skincareConcernsOther: string;
  acneAcknowledgment: 'understand' | 'not_applicable' | null;
  facialReasons: string[];
  facialReasonsOther: string;
  dailyProducts: string[];
  dailyProductsOther: string;

  // Allergies & Sensitivities
  allergies: string[];
  allergiesOther: string;
  diagnosedConditions: boolean | null;
  currentRashesRedness: string;
  activeProducts: string[];

  // Treatment History
  chemicalPeelsHistory: 'within_1_month' | 'within_2_3_months' | 'no' | null;
  botoxPast7Days: boolean | null;
  fillersPast14Days: boolean | null;

  // Medical History
  healthConditions: string[];
  healthConditionsOther: string;
  medications: string;

  // Female-specific
  birthControl: boolean | null;
  pregnantOrBreastfeeding: boolean | null;

  // Signature
  signatureDataUrl: string | null;
  signedAt: string | null;
}

// Initial empty form data
export const initialFormData: FacialConsentFormData = {
  firstName: '',
  lastName: '',
  phone: '',
  email: '',
  addressStreet: '',
  addressStreet2: '',
  addressCity: '',
  addressState: '',
  addressZip: '',
  hadFacialBefore: null,
  skincareConcerns: [],
  skincareConcernsOther: '',
  acneAcknowledgment: null,
  facialReasons: [],
  facialReasonsOther: '',
  dailyProducts: [],
  dailyProductsOther: '',
  allergies: [],
  allergiesOther: '',
  diagnosedConditions: null,
  currentRashesRedness: '',
  activeProducts: [],
  chemicalPeelsHistory: null,
  botoxPast7Days: null,
  fillersPast14Days: null,
  healthConditions: [],
  healthConditionsOther: '',
  medications: '',
  birthControl: null,
  pregnantOrBreastfeeding: null,
  signatureDataUrl: null,
  signedAt: null,
};

interface FacialConsentFormProps {
  initialData?: Partial<FacialConsentFormData>;
  onSubmit: (data: FacialConsentFormData) => Promise<void>;
  isSubmitting?: boolean;
  readOnly?: boolean;
  signatureLocked?: boolean;
  existingSignatureUrl?: string | null;
}

const FacialConsentForm: React.FC<FacialConsentFormProps> = ({
  initialData,
  onSubmit,
  isSubmitting = false,
  readOnly = false,
  signatureLocked = false,
  existingSignatureUrl = null,
}) => {
  const [formData, setFormData] = useState<FacialConsentFormData>({
    ...initialFormData,
    ...initialData,
  });
  const [errors, setErrors] = useState<Record<string, string>>({});
  const [currentSection, setCurrentSection] = useState(0);

  // Update form data when initialData changes
  useEffect(() => {
    if (initialData) {
      setFormData(prev => ({ ...prev, ...initialData }));
    }
  }, [initialData]);

  // Handle text input changes
  const handleInputChange = (field: keyof FacialConsentFormData, value: string) => {
    if (readOnly) return;
    setFormData(prev => ({ ...prev, [field]: value }));
    if (errors[field]) {
      setErrors(prev => ({ ...prev, [field]: '' }));
    }
  };

  // Handle checkbox array changes
  const handleCheckboxChange = (field: keyof FacialConsentFormData, value: string, checked: boolean) => {
    if (readOnly) return;
    setFormData(prev => {
      const currentArray = (prev[field] as string[]) || [];
      if (checked) {
        return { ...prev, [field]: [...currentArray, value] };
      } else {
        return { ...prev, [field]: currentArray.filter(v => v !== value) };
      }
    });
  };

  // Handle radio/boolean changes
  const handleBooleanChange = (field: keyof FacialConsentFormData, value: boolean | null) => {
    if (readOnly) return;
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  // Handle signature change
  const handleSignatureChange = (signatureDataUrl: string | null) => {
    if (readOnly || signatureLocked) return;
    setFormData(prev => ({
      ...prev,
      signatureDataUrl,
      signedAt: signatureDataUrl ? new Date().toISOString() : null,
    }));
  };

  // Validate form - returns errors object for immediate use (since setState is async)
  const validateForm = (): { isValid: boolean; validationErrors: Record<string, string> } => {
    const newErrors: Record<string, string> = {};

    if (!formData.firstName.trim()) newErrors.firstName = 'First name is required';
    if (!formData.lastName.trim()) newErrors.lastName = 'Last name is required';
    if (!formData.phone.trim()) newErrors.phone = 'Phone number is required';
    if (!formData.email.trim()) newErrors.email = 'Email is required';
    if (formData.hadFacialBefore === null) newErrors.hadFacialBefore = 'Please select an option';
    if (formData.dailyProducts.length === 0) newErrors.dailyProducts = 'Please select at least one option';
    if (formData.allergies.length === 0) newErrors.allergies = 'Please select at least one option';
    if (!formData.signatureDataUrl && !existingSignatureUrl) newErrors.signature = 'Signature is required';

    // Check if acne is selected and acknowledgment is needed
    if (formData.skincareConcerns.includes('acne') && formData.acneAcknowledgment === null) {
      newErrors.acneAcknowledgment = 'Please acknowledge the acne statement';
    }

    setErrors(newErrors);
    return { isValid: Object.keys(newErrors).length === 0, validationErrors: newErrors };
  };

  // Handle form submission
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (readOnly) return;

    const { isValid, validationErrors } = validateForm();
    if (!isValid) {
      // Scroll to first error using the returned errors (not stale state)
      const firstErrorKey = Object.keys(validationErrors)[0];
      const errorElement = document.getElementById(firstErrorKey);
      if (errorElement) {
        errorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      return;
    }

    await onSubmit(formData);
  };

  // Sections for navigation
  const sections = [
    { id: 'personal', title: 'Personal Information', titleCn: '个人信息' },
    { id: 'skin', title: 'Your Skin', titleCn: '您的肌肤' },
    { id: 'allergies', title: 'Allergies & Sensitivities', titleCn: '过敏与敏感' },
    { id: 'treatment', title: 'Treatment History', titleCn: '治疗历史' },
    { id: 'medical', title: 'Medical History', titleCn: '医疗历史' },
    { id: 'female', title: 'Female Clients', titleCn: '女性客户' },
    { id: 'acknowledgment', title: 'Acknowledgment', titleCn: '确认与签字' },
  ];

  // Checkbox group component
  const CheckboxGroup = ({
    options,
    field,
    otherField,
  }: {
    options: { value: string; label: string; labelCn: string }[];
    field: keyof FacialConsentFormData;
    otherField?: keyof FacialConsentFormData;
  }) => (
    <div className="space-y-2">
      {options.map(option => (
        <label key={option.value} className="flex items-start gap-2 cursor-pointer">
          <input
            type="checkbox"
            checked={(formData[field] as string[])?.includes(option.value) || false}
            onChange={(e) => handleCheckboxChange(field, option.value, e.target.checked)}
            disabled={readOnly}
            className="mt-1 h-4 w-4 text-[#3A5E63] border-gray-300 rounded focus:ring-[#3A5E63]"
          />
          <span className="text-sm text-gray-700">
            {option.label} <span className="text-gray-400">{option.labelCn}</span>
          </span>
        </label>
      ))}
      {otherField && (formData[field] as string[])?.includes('other') && (
        <input
          type="text"
          value={(formData[otherField] as string) || ''}
          onChange={(e) => handleInputChange(otherField, e.target.value)}
          placeholder="Please specify..."
          disabled={readOnly}
          className="mt-2 w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#3A5E63]"
        />
      )}
    </div>
  );

  // Yes/No radio component
  const YesNoRadio = ({
    field,
    label,
    labelCn,
  }: {
    field: keyof FacialConsentFormData;
    label: string;
    labelCn: string;
  }) => (
    <div className="space-y-2">
      <p className="text-sm font-medium text-gray-700">
        {label} <span className="text-gray-400 font-normal">{labelCn}</span>
      </p>
      <div className="flex gap-4">
        <label className="flex items-center gap-2 cursor-pointer">
          <input
            type="radio"
            name={field}
            checked={formData[field] === true}
            onChange={() => handleBooleanChange(field, true)}
            disabled={readOnly}
            className="h-4 w-4 text-[#3A5E63] border-gray-300 focus:ring-[#3A5E63]"
          />
          <span className="text-sm">Yes <span className="text-gray-400">是</span></span>
        </label>
        <label className="flex items-center gap-2 cursor-pointer">
          <input
            type="radio"
            name={field}
            checked={formData[field] === false}
            onChange={() => handleBooleanChange(field, false)}
            disabled={readOnly}
            className="h-4 w-4 text-[#3A5E63] border-gray-300 focus:ring-[#3A5E63]"
          />
          <span className="text-sm">No <span className="text-gray-400">否</span></span>
        </label>
      </div>
      {errors[field] && <p className="text-red-500 text-xs">{errors[field]}</p>}
    </div>
  );

  return (
    <form onSubmit={handleSubmit} className="space-y-8">
      {/* Section Navigation */}
      <div className="flex flex-wrap gap-2 mb-6">
        {sections.map((section, index) => (
          <button
            key={section.id}
            type="button"
            onClick={() => {
              const element = document.getElementById(section.id);
              element?.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }}
            className={`px-3 py-1 text-sm rounded-full transition-colors ${
              currentSection === index
                ? 'bg-[#3A5E63] text-white'
                : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
            }`}
          >
            {section.title}
          </button>
        ))}
      </div>

      {/* Section 1: Personal Information */}
      <section id="personal" className="bg-white rounded-lg p-6 shadow-sm border border-gray-100">
        <h2 className="text-xl font-semibold text-[#3A5E63] mb-4">
          Personal Information <span className="text-gray-400 font-normal text-base">个人信息</span>
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {/* First Name */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              First Name <span className="text-gray-400">名</span> *
            </label>
            <input
              id="firstName"
              type="text"
              value={formData.firstName}
              onChange={(e) => handleInputChange('firstName', e.target.value)}
              disabled={readOnly}
              className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-[#3A5E63] ${
                errors.firstName ? 'border-red-500' : 'border-gray-300'
              }`}
            />
            {errors.firstName && <p className="text-red-500 text-xs mt-1">{errors.firstName}</p>}
          </div>

          {/* Last Name */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Last Name <span className="text-gray-400">姓</span> *
            </label>
            <input
              id="lastName"
              type="text"
              value={formData.lastName}
              onChange={(e) => handleInputChange('lastName', e.target.value)}
              disabled={readOnly}
              className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-[#3A5E63] ${
                errors.lastName ? 'border-red-500' : 'border-gray-300'
              }`}
            />
            {errors.lastName && <p className="text-red-500 text-xs mt-1">{errors.lastName}</p>}
          </div>

          {/* Phone */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Phone Number <span className="text-gray-400">电话</span> *
            </label>
            <input
              id="phone"
              type="tel"
              value={formData.phone}
              onChange={(e) => handleInputChange('phone', e.target.value)}
              disabled={readOnly}
              className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-[#3A5E63] ${
                errors.phone ? 'border-red-500' : 'border-gray-300'
              }`}
            />
            {errors.phone && <p className="text-red-500 text-xs mt-1">{errors.phone}</p>}
          </div>

          {/* Email */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Email <span className="text-gray-400">电子邮箱</span> *
            </label>
            <input
              id="email"
              type="email"
              value={formData.email}
              onChange={(e) => handleInputChange('email', e.target.value)}
              disabled={readOnly}
              className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-[#3A5E63] ${
                errors.email ? 'border-red-500' : 'border-gray-300'
              }`}
            />
            {errors.email && <p className="text-red-500 text-xs mt-1">{errors.email}</p>}
          </div>
        </div>

        {/* Address */}
        <div className="mt-4 space-y-3">
          <label className="block text-sm font-medium text-gray-700">
            Address <span className="text-gray-400">地址</span>
          </label>
          <input
            type="text"
            value={formData.addressStreet}
            onChange={(e) => handleInputChange('addressStreet', e.target.value)}
            placeholder="Street Address"
            disabled={readOnly}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#3A5E63]"
          />
          <input
            type="text"
            value={formData.addressStreet2}
            onChange={(e) => handleInputChange('addressStreet2', e.target.value)}
            placeholder="Street Address Line 2"
            disabled={readOnly}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#3A5E63]"
          />
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
            <input
              type="text"
              value={formData.addressCity}
              onChange={(e) => handleInputChange('addressCity', e.target.value)}
              placeholder="City"
              disabled={readOnly}
              className="px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#3A5E63]"
            />
            <input
              type="text"
              value={formData.addressState}
              onChange={(e) => handleInputChange('addressState', e.target.value)}
              placeholder="State"
              disabled={readOnly}
              className="px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#3A5E63]"
            />
            <input
              type="text"
              value={formData.addressZip}
              onChange={(e) => handleInputChange('addressZip', e.target.value)}
              placeholder="ZIP Code"
              disabled={readOnly}
              className="col-span-2 md:col-span-2 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#3A5E63]"
            />
          </div>
        </div>
      </section>

      {/* Section 2: Your Skin */}
      <section id="skin" className="bg-white rounded-lg p-6 shadow-sm border border-gray-100">
        <h2 className="text-xl font-semibold text-[#3A5E63] mb-4">
          Your Skin <span className="text-gray-400 font-normal text-base">您的肌肤</span>
        </h2>

        <div className="space-y-6">
          {/* Had facial before */}
          <YesNoRadio
            field="hadFacialBefore"
            label="Have you had a facial before?"
            labelCn="您以前做过面部护理吗？"
          />

          {/* Skincare Concerns */}
          <div>
            <p className="text-sm font-medium text-gray-700 mb-2">
              What are your specific skincare concerns?{' '}
              <span className="text-gray-400 font-normal">您有哪些具体的护肤问题？</span>
            </p>
            <CheckboxGroup
              options={SKINCARE_CONCERNS}
              field="skincareConcerns"
              otherField="skincareConcernsOther"
            />
          </div>

          {/* Acne Acknowledgment - only show if acne is selected */}
          {formData.skincareConcerns.includes('acne') && (
            <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
              <p className="text-sm text-yellow-800 mb-3">
                <strong>*If you have acne:</strong> I understand Healing Lotus: Sound Therapy And Skin SPA
                will only help clear out congestion and some current blemishes. It will not prevent future
                congestion or blemishes. If you need help clearing acne, we have an acne program and can
                schedule you for a acne clearing program first time consultation at a later date.
              </p>
              <div className="space-y-2">
                <label className="flex items-center gap-2 cursor-pointer">
                  <input
                    type="radio"
                    name="acneAcknowledgment"
                    checked={formData.acneAcknowledgment === 'understand'}
                    onChange={() => setFormData(prev => ({ ...prev, acneAcknowledgment: 'understand' }))}
                    disabled={readOnly}
                    className="h-4 w-4 text-[#3A5E63]"
                  />
                  <span className="text-sm">I understand</span>
                </label>
                <label className="flex items-center gap-2 cursor-pointer">
                  <input
                    type="radio"
                    name="acneAcknowledgment"
                    checked={formData.acneAcknowledgment === 'not_applicable'}
                    onChange={() => setFormData(prev => ({ ...prev, acneAcknowledgment: 'not_applicable' }))}
                    disabled={readOnly}
                    className="h-4 w-4 text-[#3A5E63]"
                  />
                  <span className="text-sm">Not applicable</span>
                </label>
              </div>
              {errors.acneAcknowledgment && (
                <p className="text-red-500 text-xs mt-2">{errors.acneAcknowledgment}</p>
              )}
            </div>
          )}

          {/* Facial Reasons */}
          <div>
            <p className="text-sm font-medium text-gray-700 mb-2">
              Any other reasons for a facial besides your concerns?{' '}
              <span className="text-gray-400 font-normal">除了您的护肤问题，还有其他原因让您想做面部护理吗？</span>
            </p>
            <CheckboxGroup
              options={FACIAL_REASONS}
              field="facialReasons"
              otherField="facialReasonsOther"
            />
          </div>

          {/* Daily Products */}
          <div id="dailyProducts">
            <p className="text-sm font-medium text-gray-700 mb-2">
              What do you typically use on your skin daily? *{' '}
              <span className="text-gray-400 font-normal">请告诉我们您日常护肤中通常使用哪些产品？</span>
            </p>
            <CheckboxGroup
              options={DAILY_PRODUCTS}
              field="dailyProducts"
              otherField="dailyProductsOther"
            />
            {errors.dailyProducts && <p className="text-red-500 text-xs mt-2">{errors.dailyProducts}</p>}
          </div>
        </div>
      </section>

      {/* Section 3: Allergies & Sensitivities */}
      <section id="allergies" className="bg-white rounded-lg p-6 shadow-sm border border-gray-100">
        <h2 className="text-xl font-semibold text-[#3A5E63] mb-4">
          Allergies & Sensitivities <span className="text-gray-400 font-normal text-base">过敏与敏感</span>
        </h2>

        <div className="space-y-6">
          {/* Known Allergies */}
          <div id="allergies-select">
            <p className="text-sm font-medium text-gray-700 mb-2">
              Any known allergies? *{' '}
              <span className="text-gray-400 font-normal">您有已知的过敏史吗？</span>
            </p>
            <CheckboxGroup
              options={ALLERGIES}
              field="allergies"
              otherField="allergiesOther"
            />
            {errors.allergies && <p className="text-red-500 text-xs mt-2">{errors.allergies}</p>}
          </div>

          {/* Diagnosed Conditions */}
          <YesNoRadio
            field="diagnosedConditions"
            label="Have you ever been diagnosed with eczema, psoriasis or rosacea on the face?"
            labelCn="您是否曾被诊断出面部患有湿疹、牛皮癣或玫瑰痤疮？"
          />

          {/* Active Products */}
          <div>
            <p className="text-sm font-medium text-gray-700 mb-2">
              Are you currently using any products that contain:{' '}
              <span className="text-gray-400 font-normal">您目前是否正在使用含有以下成分的产品：</span>
            </p>
            <CheckboxGroup options={ACTIVE_PRODUCTS} field="activeProducts" />
          </div>

          {/* Current Rashes */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Do you currently have any rashes, itching or underlying redness on your face?{' '}
              <span className="text-gray-400 font-normal">您目前面部是否有任何皮疹、瘙痒或潜在的红肿？</span>
            </label>
            <textarea
              value={formData.currentRashesRedness}
              onChange={(e) => handleInputChange('currentRashesRedness', e.target.value)}
              disabled={readOnly}
              rows={3}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#3A5E63]"
            />
          </div>
        </div>
      </section>

      {/* Section 4: Treatment History */}
      <section id="treatment" className="bg-white rounded-lg p-6 shadow-sm border border-gray-100">
        <h2 className="text-xl font-semibold text-[#3A5E63] mb-4">
          Treatment History <span className="text-gray-400 font-normal text-base">治疗历史</span>
        </h2>

        <div className="space-y-6">
          {/* Chemical Peels History */}
          <div>
            <p className="text-sm font-medium text-gray-700 mb-2">
              Have you ever received chemical peels, laser services, or microdermabrasion treatments?{' '}
              <span className="text-gray-400 font-normal">您是否曾接受过化学换肤、激光治疗或微晶磨皮护理？</span>
            </p>
            <div className="space-y-2">
              {[
                { value: 'within_1_month', label: 'YES, within the last month', labelCn: '是的，在过去一个月内' },
                { value: 'within_2_3_months', label: 'YES, within the last 2-3 months', labelCn: '是的，在过去2-3个月内' },
                { value: 'no', label: 'NO', labelCn: '否' },
              ].map(option => (
                <label key={option.value} className="flex items-center gap-2 cursor-pointer">
                  <input
                    type="radio"
                    name="chemicalPeelsHistory"
                    checked={formData.chemicalPeelsHistory === option.value}
                    onChange={() => setFormData(prev => ({ ...prev, chemicalPeelsHistory: option.value as any }))}
                    disabled={readOnly}
                    className="h-4 w-4 text-[#3A5E63]"
                  />
                  <span className="text-sm">
                    {option.label} <span className="text-gray-400">{option.labelCn}</span>
                  </span>
                </label>
              ))}
            </div>
          </div>

          {/* Botox */}
          <YesNoRadio
            field="botoxPast7Days"
            label="Have you had botox in the past 7 days?"
            labelCn="您在过去7天内是否注射过肉毒杆菌？"
          />

          {/* Fillers */}
          <YesNoRadio
            field="fillersPast14Days"
            label="Have you had fillers in the past 14 days?"
            labelCn="您在过去14天内是否注射过填充剂？"
          />
        </div>
      </section>

      {/* Section 5: Medical History */}
      <section id="medical" className="bg-white rounded-lg p-6 shadow-sm border border-gray-100">
        <h2 className="text-xl font-semibold text-[#3A5E63] mb-4">
          Medical History <span className="text-gray-400 font-normal text-base">医疗历史</span>
        </h2>

        <div className="space-y-6">
          {/* Health Conditions */}
          <div>
            <p className="text-sm font-medium text-gray-700 mb-2">
              Have you experienced any of these health conditions in the past or present?{' '}
              <span className="text-gray-400 font-normal">您过去或现在是否曾经历过以下健康状况？</span>
            </p>
            <CheckboxGroup
              options={HEALTH_CONDITIONS}
              field="healthConditions"
              otherField="healthConditionsOther"
            />
          </div>

          {/* Medications */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Please list medications or supplements you are currently taking.{' '}
              <span className="text-gray-400 font-normal">请列出您目前正在服用的药物或补充剂。</span>
            </label>
            <textarea
              value={formData.medications}
              onChange={(e) => handleInputChange('medications', e.target.value)}
              disabled={readOnly}
              rows={3}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#3A5E63]"
            />
          </div>
        </div>
      </section>

      {/* Section 6: Female Clients */}
      <section id="female" className="bg-white rounded-lg p-6 shadow-sm border border-gray-100">
        <h2 className="text-xl font-semibold text-[#3A5E63] mb-4">
          Female Clients <span className="text-gray-400 font-normal text-base">女性客户</span>
        </h2>

        <div className="space-y-6">
          <YesNoRadio
            field="birthControl"
            label="Are you taking birth control?"
            labelCn="您是否正在服用避孕药？"
          />

          <YesNoRadio
            field="pregnantOrBreastfeeding"
            label="Are you pregnant or breast-feeding?"
            labelCn="您是否怀孕或正在哺乳？"
          />
        </div>
      </section>

      {/* Section 7: Acknowledgment & Signature */}
      <section id="acknowledgment" className="bg-white rounded-lg p-6 shadow-sm border border-gray-100">
        <h2 className="text-xl font-semibold text-[#3A5E63] mb-4">
          Acknowledgment and Waiver <span className="text-gray-400 font-normal text-base">确认与免责声明</span>
        </h2>

        {/* Waiver Text */}
        <div className="bg-gray-50 rounded-lg p-4 mb-6 max-h-64 overflow-y-auto text-sm text-gray-700 space-y-4">
          <p>
            I hereby agree to have this treatment be performed on me. I am aware that products used in
            facials and homecare can contain tree nuts, dairy and gluten. I acknowledge that the
            estheticians at Healing Lotus: Sound Therapy And Skin SPA may use products that contain these
            ingredients or are manufactured in a plant with these ingredients. I am aware that even with
            natural ingredients there is a remote chance of an allergic reaction and there is a
            possibility of an adverse reaction to product used in facials.
          </p>
          <p>
            I am also aware that certain services should not be performed with certain medical conditions.
            I have disclosed all my known medical conditions, allergies, medications and answered all
            questions honestly on the above form and agree to update Healing Lotus: Sound Therapy And Skin
            SPA as to any changes.
          </p>
          <p>
            I acknowledge that the estheticians and staff at Healing Lotus: Sound Therapy And Skin SPA do
            not provide medical advice and I accept full responsibility to seek out such advice before
            receiving any services or products from Healing Lotus: Sound Therapy And Skin SPA. I hereby
            release, discharge and waive any and all claims against Healing Lotus: Sound Therapy And Skin
            SPA and each of their partners, employees, representatives or any person(s) performing
            services or applying any products at Healing Lotus: Sound Therapy And Skin SPA, including from
            liability and responsibility for any and all illness, injuries, damages, claims, rights and
            causes of action of any kind or nature, that may occur during or arising out of any services
            or products received on this and any future dates.
          </p>
          <hr className="my-4" />
          <p className="text-gray-500">
            本人同意接受本次护理。我知晓面部护理和家庭护肤产品可能含有坚果、乳制品和麸质成分。我了解Healing
            Lotus: Sound Therapy And Skin SPA的美容师可能会使用含有这些成分或在含有这些成分的工厂中生产的产品。
            我明白，即使是天然成分，也可能会引发过敏反应，且使用面部护理产品可能存在不良反应的可能性。
          </p>
          <p className="text-gray-500">
            我亦知晓，在某些医疗条件下，不适宜进行特定护理服务。我已如实披露所有已知的健康状况、过敏史、
            药物使用情况，并如实回答了上述表格中的所有问题，并承诺如有变化，将及时通知Healing Lotus: Sound
            Therapy And Skin SPA。
          </p>
        </div>

        {/* Signature */}
        <div id="signature" className="space-y-3">
          <label className="block text-sm font-medium text-gray-700">
            Signature <span className="text-gray-400">签字</span> *
          </label>

          {existingSignatureUrl && signatureLocked ? (
            <div className="border-2 border-gray-200 rounded-lg p-4 bg-gray-50">
              <img
                src={existingSignatureUrl}
                alt="Signature"
                className="max-h-32 mx-auto"
              />
              <p className="text-center text-sm text-gray-500 mt-2">
                Signed on {formData.signedAt ? new Date(formData.signedAt).toLocaleDateString() : 'N/A'}
              </p>
            </div>
          ) : (
            <SignatureCanvas
              onSignatureChange={handleSignatureChange}
              disabled={readOnly || signatureLocked}
              initialSignature={existingSignatureUrl}
            />
          )}

          {errors.signature && <p className="text-red-500 text-xs">{errors.signature}</p>}
        </div>

        {/* Date */}
        <div className="mt-4">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Date <span className="text-gray-400">日期</span>
          </label>
          <p className="text-gray-700">
            {formData.signedAt
              ? new Date(formData.signedAt).toLocaleDateString('en-US', {
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric',
                })
              : new Date().toLocaleDateString('en-US', {
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric',
                })}
          </p>
        </div>
      </section>

      {/* Submit Button */}
      {!readOnly && (
        <div className="pt-4">
          {/* Error Summary - shown when there are validation errors */}
          {Object.keys(errors).length > 0 && (
            <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-4">
              <div className="flex items-center gap-2 text-red-700">
                <svg className="w-5 h-5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                <span className="font-medium">Please complete all required fields</span>
              </div>
              <p className="text-red-600 text-sm mt-1 ml-7">
                {Object.keys(errors).length} field(s) need your attention. Please scroll up to review.
              </p>
              <p className="text-red-500 text-sm mt-1 ml-7">
                请完成所有必填项。共有 {Object.keys(errors).length} 个字段需要您的注意。
              </p>
            </div>
          )}

          <div className="flex justify-center">
            <button
              type="submit"
              disabled={isSubmitting}
              className="px-8 py-3 bg-[#3A5E63] text-white font-semibold rounded-lg hover:bg-[#2d4a4d] transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2"
            >
              {isSubmitting ? (
                <>
                  <span className="animate-spin h-5 w-5 border-2 border-white border-t-transparent rounded-full"></span>
                  Submitting...
                </>
              ) : (
                'Submit Consent Form'
              )}
            </button>
          </div>
        </div>
      )}
    </form>
  );
};

export default FacialConsentForm;
